var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1V2H7.5C5.84315 2 4.5 3.34315 4.5 5V8C4.5 10.7614 6.73858 13 9.5 13H15.5C18.2614 13 20.5 10.7614 20.5 8V5C20.5 3.34315 19.1569 2 17.5 2H13.5V1H11.5ZM6.5 5C6.5 4.44772 6.94772 4 7.5 4H17.5C18.0523 4 18.5 4.44772 18.5 5V8C18.5 9.65685 17.1569 11 15.5 11H9.5C7.84315 11 6.5 9.65685 6.5 8V5ZM10 9C10.8284 9 11.5 8.32843 11.5 7.5C11.5 6.67157 10.8284 6 10 6C9.17157 6 8.5 6.67157 8.5 7.5C8.5 8.32843 9.17157 9 10 9ZM15 9C15.8284 9 16.5 8.32843 16.5 7.5C16.5 6.67157 15.8284 6 15 6C14.1716 6 13.5 6.67157 13.5 7.5C13.5 8.32843 14.1716 9 15 9ZM6.5 22C6.5 18.6863 9.18629 16 12.5 16C15.8137 16 18.5 18.6863 18.5 22H20.5C20.5 17.5817 16.9183 14 12.5 14C8.08172 14 4.5 17.5817 4.5 22H6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistance);
export default __webpack_public_path__ + "static/media/assistance.b9fa8926eaea30aa348928215e0e8449.svg";
export { ForwardRef as ReactComponent };